// Easingの追加
jQuery.easing.quart = function (x, t, b, c, d) {
    return -c * ((t=t/d-1)*t*t*t - 1) + b;
};
var mailmz_top=0;

$(document).ready(function(){
	var browser=browserCheck();
	var os=osCheck();
	var device=deviceCheck();
	$("html").addClass(browser).addClass(os);


  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		var $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	var targetOffset = $target.offset().top;
      	var time = 200 + (targetOffset / 8); 
      	if(device == "sp"){
	      	targetOffset = targetOffset - 80;
	      	time = 200 + (targetOffset / 16);
      	}
        $('html,body').animate({ scrollTop: targetOffset }, time, 'quart');
				return false;
      }
    }
  });
  
  $("#wrapper").on('click','a',function(){
	  var href=$(this).attr('href');
	  if(href.indexOf("cdlabo.lifeworks.co.jp") != -1 || href.indexOf("http") == -1){
			//内部リンク
	  }else{
		  //外部リンク
		  gtag('event', 'click', {'event_category': 'link','event_label': href});
	  }
  });
	
	//mailmz
  if($(".mailmz").length){
	  var mailmz_close=$.cookie("cdlabo_mailmz_close");
	  //console.log(mailmz_close);
	  if(mailmz_close == 1){
		  $(".mailmz").css({"display":"none"});
	  }
	  $(".mailmz-close").on("click",function(){
			$(".mailmz").css({"display":"none"});
			$.cookie("cdlabo_mailmz_close", 1, { expires: ""});
		});
  }
  
  if($(".mh").length){
		$(".mh").matchHeight();
	}
  if($(".objfit").length){
	  objectFitImages('img.objfit');
  }
  
  $("#menu-btn").click(function(){
	  $("#menu").toggleClass("open");
  });
  
  if($(".key").length){
	  var touch = true;
	  if(browser=="chrome"){
		  touch = false;
	  }
		var key=$('.slide-body').bxSlider({
			speed:1000,
			easing:'cubic-bezier(.8,.01,.74,.99)',
			pause:9000,
			auto:true,
			controls:false,
			touchEnabled:touch,
			onSliderLoad:function(index){
				//console.log($('.slide-body li').eq(index));
				$('.slide-body li').eq(index+1).find(".key-title-box").addClass("show");
			},
			onSlideBefore:function($slideElement, oldIndex, newIndex){
				index=oldIndex;
				$('.slide-body li').eq(index+1).find(".key-title-box").removeClass("show");
			},
			onSlideAfter:function($slideElement, oldIndex, newIndex){
				$slideElement.find(".key-title-box").addClass("show");
			}
		});
	}
	if($(".valicdationform").length){
		
		/*エラー吹き出し表示*/
		var validation = $(".validationform").exValidation({
		  stepValidation: true,
		  errHoverHide:true,
		  errTipCloseBtn:false,
		  scrollAdjust:0,
		  errMsgPrefix : "",
		});
	}
	mailmz_top=$("header .share").offset().top + $("header .share").height();
	
	$(window).scroll(function () {
   	var body = window.document.body;
	 	var html = window.document.documentElement;
	 	var scrTop = body.scrollTop || html.scrollTop;
	 	var scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	
	 	
   	if(scrTop > 500){
	   	$(".pagetop").addClass("is-show");
   	}else{
	   	$(".pagetop").removeClass("is-show");
   	}
   	
   	
   	if(scrTop > mailmz_top){
			$(".mailmz").addClass("is-show");
		}else{
			$(".mailmz").removeClass("is-show");
		}
		
  });
	
	//画面サイズごとの処理
	var w = $(window).width();
	deviceFunc(w);
	
	$(window).resize(function(){
  	var w = $(window).width();
	  deviceFunc(w);
	});
	
});

//画面サイズごとの処理
function deviceFunc(w){
	var bp = [599,960,1280];
	if (w <= bp[0]) {
		//sp
		$(".tel-number").each(function(){
			var no = $(this).data("tel");
			$(this).wrap('<a href="tel:' + no + '"></a>');
		});
		
		mailmz_top=500;
		$(".ranking").prependTo(".main");
		
  } else if(w <= bp[1]){
		//tb
		mailmz_top=500;
		$(".ranking").prependTo(".main");
		
  } else if(w <= bp[2]){
		//small pc
		$(".ranking").insertAfter(".hnavi");
  } else{
  	
  }
}


/*ブラウザ判別*/
function browserCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	var av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	var ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}